import React from "react"
import { Box, Flex } from "rebass"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import Toggle from "material-ui/Toggle"
import { UploadItemArray } from "../../../../../components"
import { Counter } from "../counter"
import { typeImageAnimation, easeAnimation } from "./utils"

const itemType = []
for (let i = 0; i < typeImageAnimation.length; i++) {
  const item = typeImageAnimation[i]
  itemType.push(<MenuItem value={item.id} key={i} primaryText={item.name} />)
}

const easeList = []
for (let i = 0; i < easeAnimation.length; i++) {
  const item = easeAnimation[i]
  easeList.push(<MenuItem value={item.id} key={i} primaryText={item.name} />)
}

const BoxImageItem = (props) => {
  const {
    data,
    onToggleAnimationChecked,
    onUpdatedImageAnimation,
    list,
    indexParent,
    updateImage,
  } = props
  // console.log(data)

  return (
    <Box w={[1]}>
      <UploadItemArray
        type={`CarouselAnimationView-url_image-${indexParent}`}
        imageUrl={list[indexParent].url_image}
        onUpdateUrl={(value) => updateImage(value, "url_image")}
        title="Image Desktop"
      />
      <UploadItemArray
        type={`CarouselAnimationView-url_image_mobile-${indexParent}`}
        imageUrl={list[indexParent].url_image_mobile}
        onUpdateUrl={(value) => updateImage(value, "url_image_mobile")}
        title="Image Mobile"
      />
      <Toggle
        label="use Animation"
        style={{ width: 220 }}
        toggled={data.image.isAnimation}
        onToggle={(e) =>
          onToggleAnimationChecked(e, "isAnimation", indexParent)
        }
      />
      {data.image.isAnimation && (
        <Box w={[1]}>
          <SelectField
            floatingLabelText="Type"
            value={data.image.animation.type}
            onChange={(event, index, value) =>
              onUpdatedImageAnimation("type", value, indexParent)
            }
            maxHeight={200}
          >
            {itemType}
          </SelectField>
          <SelectField
            floatingLabelText="Ease"
            value={data.image.animation.ease}
            onChange={(event, index, value) =>
              onUpdatedImageAnimation("ease", value, indexParent)
            }
            maxHeight={200}
          >
            {easeList}
          </SelectField>
          <Flex w={[1]} direction={"row"} wrap={"wrap"} py={[1]}>
            <Counter
              isDisabled={false}
              title="Opacity"
              onSetValue={(value) =>
                onUpdatedImageAnimation("opacity", value, indexParent)
              }
              value={data.image.animation.opacity}
              interval={1}
              subtitle=""
              minValue={0}
            />
            <Counter
              isDisabled={false}
              title="Delay"
              onSetValue={(value) =>
                onUpdatedImageAnimation("delay", value, indexParent)
              }
              value={data.image.animation.delay}
              interval={1}
              subtitle=""
              minValue={0}
            />
            <Counter
              isDisabled={false}
              title="Duration"
              onSetValue={(value) =>
                onUpdatedImageAnimation("duration", value, indexParent)
              }
              value={data.image.animation.duration}
              interval={1}
              subtitle=""
              minValue={0}
            />
          </Flex>
        </Box>
      )}
    </Box>
  )
}

export { BoxImageItem, itemType, easeList }



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/carouselanimation/BoxImageItem.js